<div class="p-3 full-width" fxLayout="column" fxLayoutAlign="space-between center" fxLayoutGap="15px">
  <div class="full-width close-button-container" fxLayout="row" fxLayoutAlign="end center">
    <button (click)="close()" class="button-close-top" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5px">
    <div class="body-3-default">Client</div>
    <mat-form-field appearance="outline" class="custom-select-field">
      <mat-select (selectionChange)="selectedPropertyChanged($event)" [disabled]="isPropChangeDisabled()"
                  [ngModel]="selectedProperty.value" class="custom-select-field-value">
        <div *ngFor="let property of data.accessibleTenants">
          <mat-option class="custom-select-field-option" [value]="property.value">{{property.name}}</mat-option>
        </div>

      </mat-select>
    </mat-form-field>
  </div>

  <div class="dialog-row-container" fxLayoutAlign="center center">
    <form [formGroup]="passwordResetForm" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="18px">
      <div fxLayout="column" fxLayoutGap="5px">
        <p class="body-3-default">Email</p>
        <mat-form-field appearance="outline" class="custom-text-field" floatLabel="always">
          <input formControlName="email" matInput type="text"/>
          <mat-hint (click)="toggleChangePassword()" *ngIf="!isChangingPassword" class="btn-cursor footer-primary full-width" style="text-align: end">Change password?</mat-hint>
        </mat-form-field>
      </div>

      @if(isChangingPassword){
      <div fxLayout="column" fxLayoutGap="5px">
        <p class="body-3-default">Password</p>
        <mat-form-field appearance="outline" class="custom-text-field" floatLabel="always" hideRequiredMarker>
          <input
            [type]="hideFirstPassword ? 'password' : 'text'"
            formControlName="password" matInput required/>
          <mat-icon (click)="hideFirstPassword = !hideFirstPassword" *ngIf="hideFirstPassword" class="btn-cursor icon-password-suffix" matSuffix>visibility</mat-icon>
          <mat-icon (click)="hideFirstPassword = !hideFirstPassword" *ngIf="!hideFirstPassword" class="btn-cursor icon-password-suffix" matSuffix>visibility_off</mat-icon>
          <mat-error *ngIf="passwordResetForm.get('password')!.hasError('required')" class="link-error">Password is required</mat-error>

          <mat-error *ngIf="passwordResetForm.get('password')!.hasError('not-valid')" class="link-error">
            Password needs to meet requirements: 8 chars, 1 upper, 1 lower, 1 number, 1 special
          </mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="column" fxLayoutGap="5px">
        <p class="subheading-default">Confirm New Password</p>
        <mat-form-field appearance="outline" class="custom-text-field" floatLabel="always"
                        hideRequiredMarker>

          <input
            [type]="hideConfirmPassword ? 'password' : 'text'"
            formControlName="confirmPassword"
            matInput
            required/>

          <mat-icon (click)="hideConfirmPassword = !hideConfirmPassword" *ngIf="hideConfirmPassword" class="btn-cursor icon-password-suffix" matSuffix>visibility</mat-icon>
          <mat-icon (click)="hideConfirmPassword = !hideConfirmPassword" *ngIf="!hideConfirmPassword" class="btn-cursor icon-password-suffix" matSuffix>visibility_off</mat-icon>
          <mat-error *ngIf="passwordResetForm.get('confirmPassword')!.hasError('required')" class="link-error">Confirm password is required</mat-error>
          <mat-error *ngIf="passwordResetForm.get('confirmPassword')!.hasError('no-match')" class="link-error">Passwords do not match</mat-error>
        </mat-form-field>
      </div>

      <div class="full-width" fxLayout="row" fxLayoutAlign="center center"
           fxLayoutGap="15px">
        <button (click)="submit()" [disabled]="isSubmitting" class="button-action form-buttons" mat-flat-button
                type="submit">
          <div class="button-text">Submit</div>
        </button>
        <button (click)="toggleChangePassword()" [disabled]="isSubmitting" class="button-action-cancel form-buttons"
                mat-flat-button>
          <div class="button-text">Cancel</div>
        </button>
      </div>

      }
    </form>

  </div>

  <div class="full-width pt-10" fxLayout="row" fxLayoutAlign="center center">
    <button (click)="logout()" class="button-action logout-button" mat-flat-button>
      <div class="button-text">Log out</div>
    </button>
  </div>
</div>
